import { TBColumn } from "../../interfaces/TableBits.interfaces";
const columns: TBColumn[] = [
  {
    id: "bussinesName",
    label: "Nombre del candidato",
    align: "left",
    width: 250,
  },
  {
    id: "comment",
    label: "Razón",
    align: "left",
    width: 500,
  },
];

export default columns;
